import { Typography } from '@mui/material';
import ManageRestaurantTable from '../ManageRestaurantTable';

const ManageRestaurantList = () => {
  return (
    <>
      <Typography variant="h5" fontWeight="bold" mb={2}>
        Store Management
      </Typography>
      <ManageRestaurantTable />
    </>
  );
};

export default ManageRestaurantList;
